import React from "react";
import "../../assets/css/components/skeletoloadig/WorkerProfileSkeleton.css";
const WorkerProfileSkeleton = () => {
  return (
    <div className="wps-page">

      {/* Mobile Header */}
      <div className="wps-header shimmer">
        <div className="wps-back"></div>
        <div className="wps-title"></div>
      </div>

      {/* Hero */}
      <div className="wps-hero shimmer">
        <div className="wps-avatar"></div>

        <div className="wps-name"></div>

        <div className="wps-subtitle"></div>

        <div className="wps-rating"></div>

        <div className="wps-location"></div>
      </div>

      {/* Stats */}
      <div className="wps-stats">
        {[1,2,3].map((i)=>(
          <div key={i} className="wps-stat shimmer">
            <div className="wps-stat-number"></div>
            <div className="wps-stat-text"></div>
          </div>
        ))}
      </div>

      {/* Edit Button */}
      <div className="wps-btn shimmer"></div>

      {/* Info Cards */}
      <div className="wps-info">
        {[1,2].map((i)=>(
          <div key={i} className="wps-info-card shimmer">
            <div className="wps-icon"></div>

            <div className="wps-info-content">
              <div className="wps-line"></div>
              <div className="wps-small"></div>
            </div>
          </div>
        ))}
      </div>

      {/* Switch Card */}
      <div className="wps-switch shimmer">
        <div className="wps-icon"></div>

        <div className="wps-info-content">
          <div className="wps-line"></div>
          <div className="wps-small"></div>
        </div>
      </div>

      {/* Menu */}
      <div className="wps-menu">
        {[1,2,3,4,5].map((i)=>(
          <div key={i} className="wps-menu-item shimmer">
            <div className="wps-icon"></div>

            <div className="wps-line"></div>
          </div>
        ))}
      </div>

      {/* Logout */}
      <div className="wps-logout shimmer"></div>

    </div>
  );
};

export default WorkerProfileSkeleton;